import * as React from 'react'
import { createComponent } from '@cloudflare/style-container'
import { RequestStatusCodeIndicator } from './RequestStatusCodeIndicator'

export type TRequestStatusIndicatorProps = {
  code: number
  text: string
}

export const RequestStatusIndicator = ({ code, text }: TRequestStatusIndicatorProps) => (
  <RequestStatusIndicatorWrapper>
    <RequestStatusCodeIndicator statusCode={code} />
    <RequestStatusIndicatorTextWrapper>{text}</RequestStatusIndicatorTextWrapper>
  </RequestStatusIndicatorWrapper>
)

const RequestStatusIndicatorWrapper = createComponent(({ theme }: { theme: any }) => ({
  display: 'inline-block',
  marginRight: '1rem',
  verticalAlign: 'middle',
  fontSize: '0.9rem',
}))

const RequestStatusIndicatorTextWrapper = createComponent(
  ({ theme }: { theme: any }) => ({
    display: 'inline-block',
    marginLeft: '1rem',
    padding: '0.74rem 0',
  }),
)



// WEBPACK FOOTER //
// ./node_modules/@cloudflare/cf-component-request-status-indicator/src/RequestStatusIndicator.tsx